import { FormState } from "react-hook-form";
import { ChatBotSettingsFormValues } from "../types";

const LOADER_SETTINGS_FIELDS: (keyof ChatBotSettingsFormValues)[] = [
  "buttonIcon",
  "buttonColor",
  "alignment",
  "sideSpacing",
  "bottomSpacing",
  "ctas",
  "ctaVisualEnabled",
  "ctaVisual",
];

export const haveChangedLoaderSettings = (
  formState: FormState<ChatBotSettingsFormValues>
) =>
  LOADER_SETTINGS_FIELDS.some(
    (fieldName) => fieldName in formState.dirtyFields
  );
